import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()
@Component({
  selector: 'app-access-message',
  templateUrl: './access-message.component.html',
  styles: []
})
export class AccessMessageComponent implements OnInit, OnDestroy {

  constructor(
    private dialogRef: MatDialogRef<AccessMessageComponent>
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  closeClick() {
    this.dialogRef.close();
  }
}
